// src/points/UserPoints.jsx
import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Grid,
  Paper,
  Typography,
  // Card,
  // CardContent,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LinearProgress,
  Avatar,
  Divider,
  Stack,
  IconButton,
  // Tooltip,
  useMediaQuery,
  useTheme,
  Fade,
  Snackbar,
  Alert,
  TextField,
  CircularProgress,
  // List,
  // ListItem,
  // ListItemAvatar,
  // ListItemText,
  // ListItemSecondaryAction,
  Tab,
  Tabs,
  // Zoom,
  RadioGroup,
  FormControlLabel,
  Radio,
  Container,
} from '@mui/material';
import {
  FaCoins,
  FaGift,
  FaExchangeAlt,
  FaHistory,
  FaCheckCircle,
  FaClock,
  // FaTimesCircle,
  // FaTrophy,
  // FaLeaf,
  // FaTree,
  // FaRecycle,
  // FaWater,
  // FaTrashAlt,
  FaMoneyBillWave,
  FaMobile,
  FaMobileAlt,
  FaPhone,
  FaWhatsapp,
  FaBan,
  FaRedo,
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { usePoints } from './PointsContext';
import SummaryCards from './SummaryCards';
import PointPrizes from './PointPrizes';
import PointsHistory from './PointsHistory';

// const MotionPaper = motion(Paper);

// Withdrawal methods
const WITHDRAWAL_METHODS = [
  {
    id: 'mpesa',
    name: 'M-Pesa',
    icon: <FaMobileAlt size={20} />,
    color: '#4CAF50',
    bgColor: '#e8f5e9',
    placeholder: '0712345678',
  },
  {
    id: 'airtel',
    name: 'Airtel Money',
    icon: <FaPhone size={20} />,
    color: '#FF5722',
    bgColor: '#fbe9e7',
    placeholder: '0712345678',
  },
  {
    id: 'tigo',
    name: 'Tigo Pesa',
    icon: <FaMobile size={20} />,
    color: '#E91E63',
    bgColor: '#fce4ec',
    placeholder: '0712345678',
  },
  {
    id: 'halopesa',
    name: 'HaloPesa',
    icon: <FaWhatsapp size={20} />,
    color: '#9C27B0',
    bgColor: '#f3e5f5',
    placeholder: '0712345678',
  },
];

const UserPoints = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  
  // Get points context
  const {
    points,
    prizes,
    loading,
    fetchUserPoints,
    fetchPrizes,
    redeemPoints,
    withdrawCash,
  } = usePoints();

  const [selectedPrize, setSelectedPrize] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogType, setDialogType] = useState('prize');
  const [withdrawalMethod, setWithdrawalMethod] = useState('mpesa');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [localLoading, setLocalLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [tabValue, setTabValue] = useState(0);
  // const [hoveredCard, setHoveredCard] = useState(null);

  // Load data on mount
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    await fetchUserPoints();
    await fetchPrizes();
  };

  const handleRedeemClick = (prize) => {
    setSelectedPrize(prize);
    setDialogType(prize.type === 'cash' ? 'cash' : 'prize');
    setDialogOpen(true);
  };

  const handleRedeemConfirm = async () => {
    setLocalLoading(true);
    try {
      let result;
      if (dialogType === 'cash') {
        // Cash withdrawal
        result = await withdrawCash(
          selectedPrize.id,
          withdrawalMethod,
          phoneNumber
        );
      } else {
        // Prize redemption
        result = await redeemPoints(selectedPrize.id);
      }
      
      if (result?.success) {
        setDialogOpen(false);
        setSnackbar({
          open: true,
          message: result.message || `🎉 Successfully ${dialogType === 'cash' ? 'withdrew cash' : 'redeemed ' + selectedPrize.name}!`,
          severity: 'success',
        });
        // Refresh data
        await loadData();
      } else {
        setSnackbar({
          open: true,
          message: result?.message || 'Operation failed',
          severity: 'error',
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || 'Failed to complete operation',
        severity: 'error',
      });
    } finally {
      setLocalLoading(false);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedPrize(null);
    setPhoneNumber('');
    setWithdrawalMethod('mpesa');
  };

  // const getCategoryColor = (category) => {
  //   switch(category) {
  //     case 'verified': return '#43a047';
  //     case 'pending': return '#ff9800';
  //     case 'spammed': return '#f44336';
  //     case 'redeemed': return '#7b1fa2';
  //     default: return '#666';
  //   }
  // };

  // const getCategoryIcon = (category) => {
  //   switch(category) {
  //     case 'verified': return <FaCheckCircle />;
  //     case 'pending': return <FaClock />;
  //     case 'spammed': return <FaBan />;
  //     case 'redeemed': return <FaExchangeAlt />;
  //     default: return <FaClock />;
  //   }
  // };

  // const getCategoryLabel = (category) => {
  //   switch(category) {
  //     case 'verified': return 'Verified';
  //     case 'pending': return 'Pending';
  //     case 'spammed': return 'Spammed';
  //     case 'redeemed': return 'Redeemed';
  //     default: return category;
  //   }
  // };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const isCashWithdrawal = dialogType === 'cash';
  const isLoading = loading || localLoading;

  const handleRefresh = useCallback(async () => {
  await fetchUserPoints();
  await fetchPrizes();
}, [fetchUserPoints, fetchPrizes]);

useEffect(() => {
  const interval = setInterval(() => {
    handleRefresh();
  }, 5 * 60 * 1000);

  return () => clearInterval(interval);
}, [handleRefresh]);

  // If loading and no data yet
  if (loading && !points.totalEarned) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress sx={{ color: '#2e7d32' }} />
      </Box>
    );
  }

  return (
    <Box sx={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, rgba(0,40,15,0.15), rgba(0,60,25,0.10), rgba(0,40,15,0.15))',
      backdropFilter: 'blur(2px)',
      py: isMobile ? 2 : 4,
      px: isMobile ? 1 : 2,
    }}>
      <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
        {/* Header */}
        <Box mb={4}>
          <Typography 
            variant={isMobile ? "h5" : "h4"} 
            fontWeight="bold" 
            color="#0ec617" 
            gutterBottom
            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
          >
            <FaCoins size={isMobile ? 24 : 32} color="#0ec617" />
            Points Dashboard
          </Typography>
          <Typography  variant="body2"  color="#88ee8d" >
            Track your points, redeem rewards, and make a difference!
          </Typography>

            {/* Refresh */}
            <IconButton
              onClick={handleRefresh}
              aria-label="Refresh"
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                color: '#0ec617',
                bgcolor: 'rgba(21, 255, 32, 0.28)',
                border: '1px solid',
                borderColor: 'rgba(46, 125, 50, 0.15)',
                width: 40,
                height: 40,
                transition: 'all 0.2s ease',
                '&:hover': {
                  bgcolor: 'rgba(46, 125, 50, 0.12)',
                  transform: 'rotate(90deg)',
                },
              }}
            >
              <FaRedo size={27} />
            </IconButton>
        </Box>

        {/* Points Summary Cards */}
        <SummaryCards 
          isMobile={isMobile} 
          points={points}
        />

        {/* Tabs */}
        <Box sx={{ 
          mt: 4, 
          borderBottom: 2, 
          borderColor: 'rgba(46,125,50,0.2)',
          bgcolor: 'rgba(255,255,255,0.7)',
          backdropFilter: 'blur(10px)',
          borderRadius: '12px 12px 0 0',
          overflow: 'hidden',
        }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange}
            variant={isMobile ? "fullWidth" : "standard"}
            sx={{
              '& .MuiTab-root': {
                fontWeight: 600,
                textTransform: 'none',
                fontSize: isMobile ? '0.8rem' : '0.95rem',
                minHeight: isMobile ? 48 : 64,
                '&.Mui-selected': {
                  color: '#2e7d32',
                },
              },
              '& .MuiTabs-indicator': {
                bgcolor: '#2e7d32',
                height: 3,
              },
            }}
          >
            <Tab 
              icon={<FaGift size={isMobile ? 14 : 18} />} 
              label={isMobile ? "Prizes" : "Prizes & Cash"} 
              iconPosition="start"
            />
            <Tab 
              icon={<FaHistory size={isMobile ? 14 : 18} />} 
              label={isMobile ? "History" : "History"} 
              iconPosition="start"
            />
          </Tabs>
        </Box>

        {/* Prize Section */}
        {tabValue === 0 && (
          <PointPrizes
            prizes={prizes}
            points={points}
            onRedeemClick={(prize) => handleRedeemClick(prize)}
            isMobile={isMobile}
          />
        )}

        {/* Points History with 4 Categories */}
        {tabValue === 1 && (
          <PointsHistory 
            historyData={points.history || []}
            isMobile={isMobile}
          />
        )}

        {/* Redeem/Cash Dialog */}
        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          maxWidth="sm"
          fullWidth
          TransitionComponent={Fade}
          transitionDuration={400}
          PaperProps={{
            sx: {
              borderRadius: '16px',
              maxHeight: '90vh',
              bgcolor: 'rgba(255,255,255,0.95)',
              backdropFilter: 'blur(10px)',
            }
          }}
        >
          <DialogTitle sx={{ 
            bgcolor: isCashWithdrawal ? 'rgba(255,243,224,0.8)' : 'rgba(245,250,246,0.8)', 
            borderBottom: '1px solid rgba(0,0,0,0.06)' 
          }}>
            <Box display="flex" alignItems="center" gap={1}>
              <Avatar sx={{ 
                bgcolor: isCashWithdrawal ? '#e65100' : '#2e7d32',
                width: 40,
                height: 40,
              }}>
                {isCashWithdrawal ? <FaMoneyBillWave size={20} color="#fff" /> : <FaExchangeAlt size={20} color="#fff" />}
              </Avatar>
              <Typography variant="h6" fontWeight="bold" sx={{ color: '#1a1a2e' }}>
                {isCashWithdrawal ? 'Withdraw Cash' : 'Redeem Prize'}
              </Typography>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ mt: 2, p: isMobile ? 2 : 3 }}>
            {selectedPrize && (
              <Box>
                <Box display="flex" alignItems="center" gap={2} mb={2}>
                  <Avatar 
                    sx={{ 
                      bgcolor: isCashWithdrawal ? '#e65100' : '#2e7d32', 
                      width: 56, 
                      height: 56,
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    }}
                  >
                    {selectedPrize.icon || <FaGift size={28} color="#fff" />}
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight={600} sx={{ color: '#1a1a2e' }}>
                      {selectedPrize.name}
                    </Typography>
                    <Chip
                      label={selectedPrize.category}
                      size="small"
                      sx={{ 
                        bgcolor: isCashWithdrawal ? 'rgba(230,81,0,0.1)' : 'rgba(46,125,50,0.1)',
                        color: isCashWithdrawal ? '#e65100' : '#2e7d32',
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Box>

                <Typography variant="body2" sx={{ color: '#424242', mb: 2 }}>
                  {selectedPrize.description}
                </Typography>

                <Divider sx={{ my: 2 }} />

                <Stack spacing={1.5}>
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="body2" sx={{ color: '#757575' }}>Points Required:</Typography>
                    <Typography variant="body2" fontWeight="bold" sx={{ color: isCashWithdrawal ? '#e65100' : '#2e7d32' }}>
                      {selectedPrize.points_required} pts
                    </Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="body2" sx={{ color: '#757575' }}>Your Redeemable Points:</Typography>
                    <Typography variant="body2" fontWeight="bold" sx={{ color: '#1a1a2e' }}>
                      {points.redeemable || 0} pts
                    </Typography>
                  </Box>
                  <LinearProgress
                    variant="determinate"
                    value={Math.min(((points.redeemable || 0) / selectedPrize.points_required) * 100, 100)}
                    sx={{
                      height: 8,
                      borderRadius: 4,
                      bgcolor: 'rgba(0,0,0,0.06)',
                      '& .MuiLinearProgress-bar': {
                        bgcolor: (points.redeemable || 0) >= selectedPrize.points_required 
                          ? (isCashWithdrawal ? '#e65100' : '#43a047') 
                          : '#ff9800',
                        borderRadius: 4,
                      },
                    }}
                  />
                </Stack>

                {isCashWithdrawal && (
                  <Box sx={{ mt: 3 }}>
                    <Typography variant="subtitle2" fontWeight="600" sx={{ color: '#1a1a2e', mb: 1.5 }}>
                      Select Withdrawal Method:
                    </Typography>
                    <RadioGroup
                      value={withdrawalMethod}
                      onChange={(e) => setWithdrawalMethod(e.target.value)}
                      sx={{ mb: 2 }}
                    >
                      <Grid container spacing={1}>
                        {WITHDRAWAL_METHODS.map((method) => (
                          <Grid item xs={6} sm={6} md={6} key={method.id}>
                            <FormControlLabel
                              value={method.id}
                              control={<Radio />}
                              label={
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Box sx={{ color: method.color }}>{method.icon}</Box>
                                  <Typography variant="body2" fontWeight={500}>
                                    {method.name}
                                  </Typography>
                                </Box>
                              }
                              sx={{
                                '& .MuiFormControlLabel-label': {
                                  fontSize: isMobile ? '0.8rem' : '0.9rem',
                                },
                              }}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </RadioGroup>

                    <TextField
                      fullWidth
                      label="Phone Number"
                      placeholder={WITHDRAWAL_METHODS.find(m => m.id === withdrawalMethod)?.placeholder || '0712345678'}
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      helperText={`Enter your ${WITHDRAWAL_METHODS.find(m => m.id === withdrawalMethod)?.name} registered phone number`}
                      size={isMobile ? "small" : "medium"}
                      sx={{ mb: 2 }}
                    />

                    <Alert 
                      severity="info" 
                      sx={{ 
                        borderRadius: '8px',
                        '& .MuiAlert-message': {
                          width: '100%',
                        }
                      }}
                    >
                      <Typography variant="caption" sx={{ display: 'block', fontWeight: 500 }}>
                        You will receive <strong>{selectedPrize.points_required * 0.5} KES</strong> 
                        {' '}(1 point = 0.5 KES)
                      </Typography>
                      <Typography variant="caption" sx={{ display: 'block', color: '#757575' }}>
                        Estimated processing time: 5-30 minutes
                      </Typography>
                    </Alert>
                  </Box>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 3, bgcolor: 'rgba(250,250,250,0.8)', borderTop: '1px solid rgba(0,0,0,0.06)' }}>
            <Button 
              onClick={handleCloseDialog}
              sx={{ 
                textTransform: 'none', 
                fontWeight: 600,
                color: '#757575',
                '&:hover': { bgcolor: 'rgba(0,0,0,0.04)' },
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleRedeemConfirm}
              disabled={isLoading || (isCashWithdrawal && !phoneNumber)}
              sx={{
                bgcolor: isCashWithdrawal ? '#e65100' : '#2e7d32',
                '&:hover': { 
                  bgcolor: isCashWithdrawal ? '#bf360c' : '#1b5e20' 
                },
                textTransform: 'none',
                fontWeight: 600,
                px: 4,
                borderRadius: '8px',
              }}
            >
              {isLoading ? <CircularProgress size={24} color="inherit" /> : 
                isCashWithdrawal ? 'Withdraw Cash' : 'Confirm Redemption'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          TransitionComponent={Fade}
        >
          <Alert 
            severity={snackbar.severity} 
            variant="filled"
            sx={{
              borderRadius: '12px',
              '& .MuiAlert-icon': {
                fontSize: '1.2rem',
              },
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Container>
    </Box>
  );
};

export default UserPoints;